"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceHistory = exports.pushHistory = void 0;
const path_1 = require("./path");
const pushHistory = (history, path, state) => history.push((0, path_1.localePath)(path), state);
exports.pushHistory = pushHistory;
const replaceHistory = (history, path, state) => history.replace((0, path_1.localePath)(path), state);
exports.replaceHistory = replaceHistory;
